import { useEffect, useState } from 'react';
import { DEFAULT_HEADERS } from 'src/shared/constants';
import { PurchasedSubscription } from 'pages/Personal/Personal.types';
import { useLoader } from 'src/hooks/useLoader/LoaderContext';
import { Bundle } from 'pages/Education/Education.types';
import { BookedLesson } from 'pages/Personal/components/SubscriptionsList/SubscriptionsList.types';

const usePurchasedSubscriptions = (
	reFetch: boolean | undefined = undefined,
	includePast: boolean | undefined = false,
	includeCoursesAndEvents: boolean | undefined = false
) => {

	const { setIsLoading } = useLoader();

	const [
		purchasedSubscriptions,
		setPurchasedSubscriptions,
	] = useState<PurchasedSubscription[] | undefined>(undefined);
	const token = localStorage.getItem('token');

	useEffect(() => {
		setIsLoading(true);
		const getData = async () => {
			const data = await fetch(`${import.meta.env.VITE_API_URL}/purchased-subscriptions`, {
				method: 'GET',
				headers: {
					...DEFAULT_HEADERS,
					Authorization: `Bearer ${token}`,
				},
			});
			const jsonData = await data.json();
			let subscriptions = jsonData.filter((subscription: any) => subscription.isPaid);
			if (!includeCoursesAndEvents) {
				subscriptions = subscriptions.filter((subscription: any) => subscription.type === 'SINGLE');
			}
			if (!includePast) {
				setPurchasedSubscriptions(subscriptions.filter((subscription: any) => new Date(subscription.endDate) >= new Date()));
			} else {
				setPurchasedSubscriptions(subscriptions);
			}

			setIsLoading(false);
		};

		getData();
	}, [reFetch]);

	const getSubscriptionDetails = async (id: number, size: number) => {
		setIsLoading(true);
		const data = await fetch(`${import.meta.env.VITE_API_URL}/lessons-booking/purchased-subscriptions/${id}?page=0&size=${size}`, {
			method: 'GET',
			headers: {
				...DEFAULT_HEADERS,
				Authorization: `Bearer ${token}`,
			},
		});
		const jsonData: BookedLesson[] = await data.json();
		return jsonData;
	};

	const getBundle = async (id: number) => {
		setIsLoading(true);
		const data = await fetch(`${import.meta.env.VITE_API_URL}/lessons-bundle/${id}`, {
			method: 'GET',
			headers: {
				...DEFAULT_HEADERS,
				Authorization: `Bearer ${token}`,
			},
		});
		const jsonData: Bundle = await data.json();
		return jsonData;
	};

	return { purchasedSubscriptions, getSubscriptionDetails, getBundle };
};

export default usePurchasedSubscriptions;
